import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  CreateLeadSourceInput,
  CreateLeadStatusInput,
  LeadSourceResponse,
  LeadStatusResponse,
  ReorderInput,
  UpdateLeadSourceInput,
  UpdateLeadStatusInput,
} from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

export function useLeadStatusesQuery() {
  return useQuery({ queryKey: ['admin-lead-statuses'], queryFn: () => api.get<LeadStatusResponse[]>('/admin/lead-config/statuses') });
}
export function useCreateLeadStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateLeadStatusInput) => api.post<LeadStatusResponse>('/admin/lead-config/statuses', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-lead-statuses'] }),
  });
}
export function useUpdateLeadStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateLeadStatusInput }) => api.patch<LeadStatusResponse>(`/admin/lead-config/statuses/${id}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-lead-statuses'] }),
  });
}
export function useDeleteLeadStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/admin/lead-config/statuses/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-lead-statuses'] }),
  });
}
export function useReorderLeadStatuses() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ReorderInput) => api.patch<void>('/admin/lead-config/statuses/reorder', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-lead-statuses'] }),
  });
}

export function useLeadSourcesQuery() {
  return useQuery({ queryKey: ['admin-lead-sources'], queryFn: () => api.get<LeadSourceResponse[]>('/admin/lead-config/sources') });
}
export function useCreateLeadSource() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateLeadSourceInput) => api.post<LeadSourceResponse>('/admin/lead-config/sources', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-lead-sources'] }),
  });
}
export function useUpdateLeadSource() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateLeadSourceInput }) => api.patch<LeadSourceResponse>(`/admin/lead-config/sources/${id}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-lead-sources'] }),
  });
}
